export const getCardPosition = (
  index: number,
  total: number,
  currentIndex: number
) => {
  const relative = (index - currentIndex + total) % total;

  if (relative === 0) return 'center';
  if (relative === 1) return 'right';
  if (relative === 2) return 'right-hidden';
  if (relative === total - 1) return 'left';
  if (relative === total - 2) return 'left-hidden';

  return 'hidden';
};

export const getCardStyle = (position: string, isMobile: boolean) => {
  switch (position) {
    case 'center':
      return {
        transform: isMobile
          ? 'translateX(0)'
          : 'translateX(0) scale(1) rotateY(0deg)',
        zIndex: 10,
      };
    case 'left':
      return {
        transform: isMobile
          ? 'translateX(calc(-100% - 16px))'
          : 'translateX(-300px) scale(0.55, 0.75) rotateY(40deg)',
        zIndex: 5,
      };
    case 'right':
      return {
        transform: isMobile
          ? 'translateX(calc(100% + 16px))'
          : 'translateX(300px) scale(0.55, 0.75) rotateY(-40deg)',
        zIndex: 5,
      };
    case 'left-hidden':
      return {
        transform: isMobile
          ? 'translateX(calc(-200% - 16px))'
          : 'translateX(-510px) scale(0.35, 0.6) rotateY(80deg)',
        zIndex: 1,
      };
    case 'right-hidden':
      return {
        transform: isMobile
          ? 'translateX(calc(200% + 16px))'
          : 'translateX(510px) scale(0.35, 0.6) rotateY(-80deg)',
        zIndex: 1,
      };
    default:
      return {
        transform: isMobile
          ? 'translateX(0)'
          : 'translateX(0) scale(0) rotateY(0deg)',
        zIndex: 0,
      };
  }
};

export const COVERFLOW_SLIDER_VIP_ITEMS = [
  {
    content: 'gold',
    image: {
      src: '/lp/dragon-pearls-november-25/golden-star.webp',
      alt: 'gold',
      width: 281,
    },
    percentage: '5%',
    borderColor: '#FF7B00',
  },
  {
    content: 'platinum',
    image: {
      src: '/lp/dragon-pearls-november-25/plat-star.webp',
      alt: 'platinum',
      width: 329,
    },
    percentage: '7.5%',
    borderColor: '#CED0DA',
  },
  {
    content: 'diamond',
    image: {
      src: '/lp/dragon-pearls-november-25/diam-star.webp',
      alt: 'diamond',
      width: 333,
    },
    percentage: '10%',
    borderColor: '#A157FF',
  },
];

export const COVERFLOW_SLIDER_PAYMENTS = [
  {
    src: '/lp/dragon-pearls-november-25/visa.webp',
    alt: 'visa',
    width: 49.5,
    height: 20,
  },
  {
    src: '/lp/dragon-pearls-november-25/mastercard.webp',
    alt: 'mastercard',
    width: 32.4,
    height: 20,
  },
  {
    src: '/lp/dragon-pearls-november-25/neosurf.webp',
    alt: 'neosurf',
    width: 66.4,
    height: 20,
  },
  {
    src: '/lp/dragon-pearls-november-25/bitcoin.webp',
    alt: 'bitcoin',
    width: 53.54,
    height: 20,
  },
  {
    src: '/lp/dragon-pearls-november-25/bitcoin-cash.webp',
    alt: 'bitcoinCash',
    width: 70,
    height: 20,
  },
  {
    src: '/lp/dragon-pearls-november-25/eth.webp',
    alt: 'eth',
    width: 55,
    height: 20,
  },
  {
    src: '/lp/dragon-pearls-november-25/litecoin.webp',
    alt: 'litecoin',
    width: 53,
    height: 20,
  },
  {
    src: '/lp/dragon-pearls-november-25/dogecoin.webp',
    alt: 'dogecoin',
    width: 50,
    height: 20,
  },
];
